module.exports = __webpack_public_path__ + "07_medium_black.1227eec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_medium_black.png
// module id = rxdI
// module chunks = 0